var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30V6.875H6.875V0H23.125V13.75H30V30H17.2083V23.125H12.7917V30H0ZM2.5 27.5H6.875V23.125H2.5V27.5ZM2.5 20.625H6.875V16.25H2.5V20.625ZM2.5 13.75H6.875V9.375H2.5V13.75ZM9.375 20.625H13.75V16.25H9.375V20.625ZM9.375 13.75H13.75V9.375H9.375V13.75ZM9.375 6.875H13.75V2.5H9.375V6.875ZM16.25 20.625H20.625V16.25H16.25V20.625ZM16.25 13.75H20.625V9.375H16.25V13.75ZM16.25 6.875H20.625V2.5H16.25V6.875ZM23.125 27.5H27.5V23.125H23.125V27.5ZM23.125 20.625H27.5V16.25H23.125V20.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.077a78c6755c0ca0eb3eccdc141d07e5.svg";
export { ForwardRef as ReactComponent };